import PropTypes from 'prop-types';

// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';
import { getSuperAdminClaim } from '@confluence/super-admin-claim';

import IsSuperAdmin from './__generated__/IsSuperAdminQuery.graphql.ts';

export const useIsSuperAdmin = () => {
	// if the claim does not exist, we'll skip doing the actual query
	const hasSuperAdminClaim = getSuperAdminClaim();

	const { loading, error, data } = useQueryInterop(IsSuperAdmin, {
		skip: !hasSuperAdminClaim,
	});

	return hasSuperAdminClaim
		? {
				loading,
				error,
				isSuperAdmin: Boolean(data?.user?.confluence?.roles?.isSuperAdmin),
			}
		: {
				loading: false,
				isSuperAdmin: false,
			};
};

export const AdminKeyQuery = ({ children }) => {
	const { isSuperAdmin, loading, error } = useIsSuperAdmin();

	return children({
		loading,
		error,
		isSuperAdmin,
	});
};

AdminKeyQuery.propTypes = {
	children: PropTypes.func.isRequired,
};
